<video
  #video
  class="vjs-matrix video-js my-custom-skin vjs-default-skin moo-css"
  (contextmenu)="contextMenu($event)"
></video>
